import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { BookmarkPlus, Trash2, FolderOpen } from 'lucide-react';
import api from '../../lib/api';

export const SavedTemplatesBar = ({ apiPath, templateId, content, onLoad }) => {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState('');
  const [saving, setSaving] = useState(false);

  const refresh = () => {
    api.get(apiPath).then(r => setTemplates(r.data?.templates || [])).catch(() => {});
  };

  useEffect(refresh, [apiPath]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSave = async () => {
    const name = window.prompt('Nombre para esta plantilla (ej: "Newsletter mensual con mi logo"):');
    if (!name || !name.trim()) return;
    setSaving(true);
    try {
      await api.post(apiPath, { name: name.trim(), template_id: templateId, content });
      toast.success('Plantilla guardada');
      refresh();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'No se pudo guardar');
    } finally {
      setSaving(false);
    }
  };

  const handleLoad = (id) => {
    setSelected(id);
    const t = templates.find(x => x.id === id);
    if (t) {
      onLoad(t);
      toast.success(`Plantilla "${t.name}" cargada`);
    }
  };

  const handleDelete = async () => {
    if (!selected) return;
    if (!window.confirm('¿Eliminar esta plantilla guardada?')) return;
    try {
      await api.delete(`${apiPath}/${selected}`);
      setSelected('');
      refresh();
      toast.success('Plantilla eliminada');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'No se pudo eliminar');
    }
  };

  return (
    <div className="rounded-lg border border-[#D4AF37]/30 bg-[#D4AF37]/5 p-3 space-y-2" data-testid="saved-templates-bar">
      <div className="flex items-center gap-1.5 text-xs text-[#D4AF37] font-semibold uppercase tracking-wider">
        <FolderOpen size={12} /> Mis plantillas guardadas
      </div>
      <div className="flex items-center gap-2">
        <select
          value={selected}
          onChange={(e) => handleLoad(e.target.value)}
          className="flex-1 min-w-0 bg-zinc-900 border border-zinc-700 rounded-md px-2.5 py-1.5 text-white text-xs"
          data-testid="saved-templates-select"
        >
          <option value="">{templates.length ? '— Cargar una plantilla —' : 'No tenés plantillas guardadas'}</option>
          {templates.map(t => (
            <option key={t.id} value={t.id}>{t.name}</option>
          ))}
        </select>
        {selected && (
          <button type="button" onClick={handleDelete} className="text-zinc-500 hover:text-red-400 flex-shrink-0" title="Eliminar plantilla" data-testid="delete-saved-template-btn">
            <Trash2 size={14} />
          </button>
        )}
        <button
          type="button"
          onClick={handleSave}
          disabled={saving}
          className="px-2.5 py-1.5 bg-[#D4AF37]/20 border border-[#D4AF37]/40 text-[#D4AF37] rounded-md text-[11px] font-semibold flex items-center gap-1.5 hover:bg-[#D4AF37]/30 flex-shrink-0"
          data-testid="save-template-btn"
        >
          <BookmarkPlus size={12} /> Guardar actual
        </button>
      </div>
      <p className="text-[10px] text-zinc-500">Guardá el diseño con tu logo, colores y bloques para reutilizarlo en futuras campañas.</p>
    </div>
  );
};
